// extracted by mini-css-extract-plugin
export default {"filterResultsSection":"FilterResultsSection_filterResultsSection__JFpV0"};